"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useStores } from "../../stores/useStores";
import { useFeatureFlags } from "../../utils/featureFlags/useFeatureFlags";
import { getPostHog } from "../../utils/posthog";

// Render once per layout. Each render sends a $pageview per route change.
export function StaffPageviewTracker() {
  const { userStore, organizationStore } = useStores();
  const featureFlags = useFeatureFlags();
  const pathname = usePathname();

  const isEnabled = featureFlags.posthog_tracking_enabled;
  const userRole = userStore.admin
    ? "admin"
    : userStore.editor
      ? "editor"
      : null;
  const orgId = organizationStore.currentOrganization?.id ?? null;
  const userId = userStore.id;

  useEffect(() => {
    if (!isEnabled || userRole === null) {
      return;
    }

    try {
      getPostHog().capture("$pageview", {
        organization_id: orgId,
        user_id: userId,
        user_role: userRole,
      });
    } catch (error) {
      if (process.env.NEXT_PUBLIC_APP_ENV === "dev") {
        console.warn("[Analytics] Failed to track pageview:", error);
      }
    }
  }, [pathname, isEnabled, userRole, orgId, userId]);

  return null;
}
